import { render, staticRenderFns } from "./AppReleaseList.vue?vue&type=template&id=2f6f16c1&"
import script from "./AppReleaseList.vue?vue&type=script&lang=js&"
export * from "./AppReleaseList.vue?vue&type=script&lang=js&"
import style0 from "./AppReleaseList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports